<template>
    <div class="d-flex flex-column align-items-center">
        <div class="col-12 d-flex justify-content-center">
            <h2>Editar a seção</h2>
        </div>
        <SectionForm 
            v-model="section"
            :mode="'edit'"
            @save="UpdateSection"
            @delete="DeleteSection"
        />
    </div>
</template>

<script>
import Swal from 'sweetalert2'
import { mapGetters, mapActions } from 'vuex'

import SectionForm from './components/Form'

export default {
    name: 'PanelSection',
    components: {
        SectionForm
    },
    props: {
        section_id: {
            type:       [String, Number],
            default:    null
        }
    },
    data () {
        return {
            section: {
                titulo:             '',
                faq_section_id:     null,
                faq_category_id:    null,
                faq_author_id:      null,
                slug:               '',
                texto:              '',
                status:             1,
                agendamento:        ''
            }
        }
    },
    computed: {
        
    },
    watch: {
        section_id: {
            immediate: true,
            async handler(val)
            {
                await this.GetSection()
            }
        }
    },
    methods: {
        ...mapActions('system', [
            'StartLoading', 'FinishLoading'
        ]),
        async UpdateSection(val)
        {
            this.section = val

            await this.SaveSection()
        },
        async GetSection()
        {
            const vm = this

            vm.StartLoading()

            return await window.api.call('post', '/faq/get-section', {
                section_id: this.section_id
            })
                .then(({data}) => {
                    if(data.response)
                    {
                        vm.section = data.section
                        return
                    }

                    Swal.fire({
                        text:       data.message,
                        icon:       'error',
                        title:      'Eita!'
                    })
                })
                .finally(() => {
                    vm.FinishLoading()
                })
        },
        SaveSection()
        {
            const vm = this

            Swal.fire({
                text:                   'Realmente deseja substituir as informações da seção?',
                title:                  'Atenção!',
                icon:                   'question',
                showCancelButton:       true,
                confirmButtonText:      'Sim, substituir',
                cancelButtonText:       'Não, cancelar'
            })
                .then(async (result) => {
                    if(result.isConfirmed)
                    {
                        vm.StartLoading()
            
                        return await window.api.call('post', '/faq/save-section', {
                            faq_section_id: vm.section.id,
                            ...vm.section
                        })
                            .then(({data}) => {
                                if(data.response)
                                {
                                    Swal.fire({
                                        title:              'Seção salva com sucesso!',
                                        icon:               'success',
                                        toast:              true,
                                        position:           'top',
                                        timer:              3000,
                                        timerProgressBar:   true,
                                        showConfirmButton:  false,
                                    })

                                    this.$router.push({ name: 'ManageSections' })
                                    
                                    return
                                }

                                Swal.fire({
                                    text:   'Ocorreu um erro ao atualizar a seção.',
                                    title:  'Eita!',
                                    icon:   'error',
                                })
                            })
                            .finally(() => {
                                vm.FinishLoading()
                            })
                    }
                })
        },
        DeleteSection()
        {
            const vm = this
            
            Swal.fire({
                title:      'Atenção!',
                text:       'Deseja realmente excluir a seção?',
                icon:       'warning',
                showCancelButton: true,
                confirmButtonText: 'Sim, excluir',
                cancelButtonText:  'Não, cancelar'
            })
            .then(async (result) => {
                if(result.isConfirmed)
                {
                    vm.StartLoading()

                    return await window.api.call('post', '/faq/delete-section', {
                        faq_section_id: vm.section_id
                    })
                        .then(({data}) => {
                            if(data.response)
                            {
                                Swal.fire({
                                    title:              'Seção excluída com sucesso!',
                                    icon:               'success',
                                    toast:              true,
                                    position:           'top',
                                    timer:              3000,
                                    timerProgressBar:   true,
                                    showConfirmButton:  false,
                                })

                                vm.$router.push({ name: 'ManageSections' })

                                return
                            }

                            Swal.fire({
                                text:   'Ocorreu um erro ao excluir a seção.',
                                title:  'Eita!',
                                icon:   'error',
                            })
                        })
                        .finally(() => {
                            vm.FinishLoading()
                        })
                }
            })
        }
    }
}
</script>

<style>

</style>